import { buildStateTypes as buildTypes } from '@dotone/react-ui-core/helpers';

export const offerTypes = {
  CURRENT: buildTypes('API_OFFER_CURRENT'),
};
